import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    tableHeader: {
      background: colors.defaultGrey
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column'
    },
    paperHeader: {
      justifyContent: 'space-between'
    },
    orderHistoryHeaderRightSection: {
      justifyContent: 'flex-end',
      alignItems: 'center'
    },
    withMarginLeft: {
      marginLeft: theme.spacing(1)
    },
    tableRowArrowCell: {
      paddingBottom: 0,
      paddingTop: 0
    },
    orangeChip: {
      color: colors.orange,
      borderColor: colors.orange
    },
    redChip: {
      color: colors.red,
      borderColor: colors.red
    },
    greenChip: {
      color: colors.green,
      borderColor: colors.green
    },
    blueChip: {
      color: colors.blue,
      borderColor: colors.blue
    },
    orderDetailsPaper: {
      marginBottom: theme.spacing(2)
    },
    smallAvatar: {
      width: theme.spacing(3),
      height: theme.spacing(3)
    },
    mt1: {
      marginTop: theme.spacing(1)
    },
    vAlignTop: {
      verticalAlign: 'top'
    },
    column: {
      display: 'flex',
      flexDirection: 'column'
    },
    mxWidthWordBreak: {
      maxWidth: 125,
      wordWrap: 'break-word'
    }
  });
});
